import React from 'react';
import { Form } from 'react-bootstrap';

import { CreateUpdateClientGroupDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import FormRow from '../../../app/components/FormRow';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface ClientGroupEditorFormProps {
  clientGroup: CreateUpdateClientGroupDto;
  propertyChange?: (obj: Partial<CreateUpdateClientGroupDto>) => void;
  readOnly?: boolean;
}

export const ClientGroupEditorForm: React.FC<
  ClientGroupEditorFormProps
> = props => {
  const { t, tk } = useTranslation('clientLng');

  return (
    <Form className="d-grid gap-3">
      <FormRow controlId="name" label={t(tk.clientGroup.groupName)}>
        <Form.Control
          type="text"
          value={props.clientGroup?.name || ''}
          onChange={e =>
            props.propertyChange &&
            props.propertyChange({ name: e.target.value })
          }
          disabled={props.readOnly}
        />
      </FormRow>
      <FormRow
        controlId="description"
        label={t(tk.clientGroup.groupDescription)}
      >
        <Form.Control
          as="textarea"
          rows={3}
          value={props.clientGroup?.description || ''}
          onChange={e =>
            props.propertyChange &&
            props.propertyChange({ description: e.target.value || null })
          }
          disabled={props.readOnly}
        />
      </FormRow>
      <FormRow controlId="active" label={t(tk.common.activeHe)}>
        <Form.Check
          type="checkbox"
          checked={props.clientGroup?.active ?? true}
          onChange={e =>
            props.propertyChange &&
            props.propertyChange({ active: e.target.checked })
          }
          disabled={props.readOnly}
        />
      </FormRow>
    </Form>
  );
};
